import {AssetType} from '@sollapay/enums';

import type {IconName} from '@sollapay/ui';

/** Clustering is visual, not structural, so it maps per type — exhaustive, to force a choice. */
export const ASSET_TYPE_ICONS: Record<AssetType, IconName> = {
  [AssetType.DEVELOPER_UNIT]: 'building',
  [AssetType.APARTMENT]: 'apartment-building',
  [AssetType.PENTHOUSE]: 'apartment-building',
  [AssetType.GARDEN_APARTMENT]: 'apartment-building',
  [AssetType.DUPLEX]: 'apartment-building',
  [AssetType.STUDIO]: 'apartment-building',
  [AssetType.HOUSE]: 'house',
  [AssetType.COTTAGE]: 'house',
  [AssetType.VILLA]: 'house',
  [AssetType.BUILDING]: 'building',
  [AssetType.LAND]: 'map',
  [AssetType.LOT]: 'map',
  [AssetType.COMMERCIAL]: 'building',
  [AssetType.OFFICE]: 'building',
  [AssetType.STORE]: 'building',
  [AssetType.INDUSTRIAL]: 'warehouse',
  [AssetType.WAREHOUSE]: 'warehouse',
  [AssetType.PARKING]: 'car',
  [AssetType.STORAGE]: 'rows',
  [AssetType.OTHER]: 'document'
};

/** A stale bundle can carry an assetType this map predates — fall back rather than render nothing. */
export function getAssetTypeIcon(assetType: AssetType): IconName {
  return ASSET_TYPE_ICONS[assetType] ?? 'building';
}
